interface Params {
  text: any;
  level: number;
}

export const header = ({ text, level }: Params, blurred: boolean) => {
  const boundedeLevel = level >= 6 || level === 0 ? "6" : `${level}`;
  return blurred ?
      `<h${boundedeLevel} class="blurred">${text}</h${boundedeLevel}>`
      : `<h${boundedeLevel}>${text}</h${boundedeLevel}>`;

};
